import {RoomSessionClientState} from '../../../../../shared/RoomSessionClientState'
import {UIRoomUserList} from '../../../../shared/scripts/ui_html/room/UIRoomUserList'
import {ViewPopupEditProfile, EditProfileTab} from '../../../../shared/scripts/ui_popup/ViewPopupEditProfile'
import {SocketLobbySend} from '../../../../shared/scripts/socket/SocketLobbySend'
import {PlayerColor} from '@colonist/game-states'
import {UIMProfileUsernameController} from '../main_page/body/UIMProfileUsernameController'
import {ViewPopupEditBotProfile} from '../../../../shared/scripts/ui_popup/ViewPopupEditBotProfile'

export class UIMRoomUserListController extends UIRoomUserList {
    // eslint-disable-next-line class-methods-use-this
    protected openEditProfileForPlayer(player: RoomSessionClientState | undefined): void {
        if(player?.isBot) {
            new ViewPopupEditBotProfile({
                usernameController: UIMProfileUsernameController,
                selectColorAction: async(color: PlayerColor) => {
                    if(player == undefined) return
                    SocketLobbySend.clickedRoomSelectColor(player.roomSessionId, color)
                },
                tab: EditProfileTab.Color,
                selectedColor: player?.selectedColor,
                username: player?.username,
            })
            return
        }

        new ViewPopupEditProfile({
            usernameController: UIMProfileUsernameController,
            selectColorAction: async(color: PlayerColor) => {
                if(player == undefined) return
                SocketLobbySend.clickedRoomSelectColor(player.roomSessionId, color)
            },
            tab: EditProfileTab.Color,
            selectedColor: player?.selectedColor,
        })
    }
}
